import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
  onNavigate: (page: string) => void;
  currentPage: string;
}
export function Layout({
  children,
  onNavigate,
  currentPage
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col bg-slate-50 relative pb-[50px] sm:pb-0" data-id="element-17512">
      <Header onNavigate={onNavigate} currentPage={currentPage} data-id="element-17513" />
      <main className="flex-grow flex flex-col" data-id="element-17514">{children}</main>
      <Footer onNavigate={onNavigate} data-id="element-17515" />
    </div>;
}